<template>
  <header
    id="mainHeader"
    ref="header"
    class="main-header"
    :class="{
      '-sticky': !staticHeader,
      '-scroll-top': isScrollTop,
      '-scroll-up': hideHeader && !openMenu && !openBag && !staticHeader,
      '-fade-out': fadeHeader && !openMenu && !openBag,
      '-black-theme': controlBlackTheme,
      '-blackest-theme': controlBlackestTheme,
      '-transparent-header-theme -transparent-header-theme-white':
        transparentHeader === 'white',
      '-transparent-header-theme -transparent-header-theme-black':
        transparentHeader === 'black',
      '-transparent-header': controlTransparentHeader,
      '-opened': openMenu,
      '-signup-bar': signUpBar,
      '-b2b-userbar': b2bUserBar,
    }"
  >
    <section>
      <B2BUserBar v-if="b2bHeader && b2bUserBar" />
      <div class="grid main-header-wrapper -p-relative">
        <LogoController
          class="g-6 main-header-icon-wrapper"
          :site="this.site"
        />
        <!-- <div class="ml-auto" /> -->
        <div class="g-10-3 d-flex justify-content-end">
          <SearchIconController
            v-if="
              !mobileHeaderOpenState &&
              !($mqAliases.desktop && openBag) &&
              !b2bHeader
            "
            class="main-header-icon-wrapper w-100 d-flex justify-content-end"
            @toggle="openMobileSearch = true"
          />
          <BagIconController
            v-if="
              !mobileHeaderOpenState &&
              !($mqAliases.desktop && openDesktopSearch)
            "
            class="main-header-icon-wrapper"
            v-model="openBag"
            @set-drawer="
              (e) => {
                bagActiveDrawer = e;
              }
            "
            :counter="cartCount"
          />
          <BurgerController
            v-if="!$mqAliases.desktop"
            class="main-header-icon-wrapper"
            :active="mobileHeaderOpenState"
            @toggle="
              !mobileHeaderOpenState ? (openMenu = true) : closeOpenNav()
            "
          />
        </div>
      </div>
      <SearchBox ref="searchbox" />

      <transition name="menu">
        <Menu
          ref="menumain"
          :site="site"
          :open="openMenu"
          :disableHover="b2bHeader"
          v-show="openMenu || $mqAliases.desktop"
        />
      </transition>

      <transition name="fade">
        <BagPreview
          v-if="bagInit"
          v-show="openBag"
          ref="menubag"
          :site="site"
          :open="openBag"
          :cartCount="cartCount"
          @mouse-active="setBagMouseState"
          @close="openBag = false"
          :startDrawer="bagActiveDrawer"
        />
      </transition>

      <!-- <portal to="modal-destination">
        <AddedToBagMobile v-if="$mqAliases.mobile" />
      </portal> -->
      <div
        v-if="!$mqAliases.desktop && !isOnSearchPage"
        class="search-field-mobile-wrapper p-l-18 p-r-18"
        :class="{ '-active': openMobileSearch }"
      >
        <SearchField
          v-if="openMobileSearch"
          ref="searchMobile"
          v-model="searchText"
        />
      </div>

      <!-- <SearchBox ref="searchbox" /> -->
      <div v-if="viewNotification">
        <portal to="notification-destination">
          <NotificationBar
            v-if="notificationSettings.ShowNotification"
            :label="notificationSettings.NotificationText"
            :url="notificationSettings.NotificationLink"
            :linkText="notificationSettings.NotificationLinkText"
            :addonClass="notificationSettings.NotificationClass"
            @close="closeNotification"
          />
        </portal>
      </div>
    </section>
    <portal-target
      name="header-bar-destination"
      class="header-bar-destination"
    ></portal-target>
    <WishlistModal />
  </header>
</template>

<script>
import Menu from '@/Scripts/components/layout/menu/Menu.vue';
import gsap from 'gsap';
import stickyHeader from './stickyHeaderHelper';
import LogoController from '@/Scripts/components/layout/Header/Assets/LogoController.vue';
import SearchIconController from '@/Scripts/components/layout/Header/Assets/SearchIconController.vue';
import BurgerController from '@/Scripts/components/layout/Header/Assets/BurgerController.vue';
import WishlistModal from '@/Scripts/components/layout/Header/Assets/WishlistModal.vue';
import BagIconController from '@/Scripts/components/layout/Header/Assets/BagIconController.vue';
import siteInfo from '@/Scripts/lib/helper/siteInfo.js';
import { mapState } from 'vuex';
import { eventBus } from '@/Scripts/lib/helper/eventBus.js';

const B2BUserBar = () => import('@/Scripts/components/layout/Header/Assets/B2BUserBar.vue');
const SearchField = () => import('@/Scripts/components/layout/Search/SearchField.vue');
const SearchBox = () => import('@/Scripts/components/layout/Search/SearchBox.vue');
const NotificationBar = () => import('@/Scripts/components/shared/NotificationBar/NotificationBar.vue');

const BagPreview = () => import('@/Scripts/components/layout/bag/BagPreview.vue');

let headerTimeout = null;

export default {
  name: 'Header',
  mixins: [siteInfo, stickyHeader],
  components: {
    Menu,
    BagPreview,
    // NewBag,
    SearchField,
    SearchBox,
    NotificationBar,
    // AddedToBagMobile,
    LogoController,
    SearchIconController,
    BurgerController,
    BagIconController,
    B2BUserBar,
    WishlistModal

  },
  data () {
    return {
      openMobileSearch: false,
      openDesktopSearch: false,
      openMenu: false,
      openBag: false,
      mouseOverBagPreview: false,
      searchText: '',
      notificationBarHidden: false,
      bagInit: false,
      activeDesktopmenuItem: null,
      bagActiveDrawer: '',
      cookieBannerActive: false
    };
  },
  computed: {
    ...mapState({
      cart: state => state.bag.cart,
      blackTheme: state => state.appContext.blackTheme,
      b2bHeader: state => state.appContext.b2bHeader,
      b2bUserBar: state => state.appContext.b2bUserBar,
      blackestTheme: state => state.appContext.blackestTheme,
      hideHeader: state => state.appContext.hideHeader,
      fadeHeader: state => state.appContext.fadeHeader,
      site: state => state.appContext.site,
      headerCallCart: state => state.appContext.headerCallCart,
      staticHeader: state => state.appContext.staticHeader,
      isScrollTop: state => state.appContext.isScrollTop,
      signUpBar: state => state.appContext.signUpBar,
      transparentHeader: state => state.appContext.transparentHeader
    }),
    cartCount () {
      if (this.site === 'b2c') {
        return this.$store.getters['bag/cartCount'];
      }
      return 0;
    },
    controlBlackTheme () {
      if (!this.$mqAliases.desktop) {
        return this.blackTheme && !(this.openBag || this.openMobileSearch);
      }
      return this.blackTheme;
    },
    controlBlackestTheme () {
      if (!this.$mqAliases.desktop) {
        return this.blackestTheme && !(this.openBag || this.openMobileSearch);
      }
      return this.blackestTheme;
    },
    controlTransparentHeader () {
      if (!this.transparentHeader) {
        return false;
      }
      if (!this.$mqAliases.desktop) {
        return this.isScrollTop && !this.openMenu && !this.openBag && !this.openMobileSearch;
      }
      return this.isScrollTop && !this.openMenu;
    },
    mobileHeaderOpenState () {
      return (this.openMenu || this.openBag || this.openMobileSearch) && !this.$mqAliases.desktop;
    },
    isOnSearchPage () {
      return window.location.search.includes('searchtext');
    },
    viewNotification () {
      return this.notificationSettings.ShowNotification && !this.notificationBarHidden && !this.transparentHeader;
    }
  },
  watch: {
    openMobileSearch (val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.searchMobile) {
            this.$refs.searchMobile.setFocus();
          }
        });
      } else {
        eventBus.$emit('SEARCH_VIEW_SEARCHBOX', false);
      }
    },
    openMenu (val) {
      if (!this.$mqAliases.desktop) {
        this.scrollLock(val, this.$refs.menumain);
        if (val) {
          this.$refs.menumain.initAllDrawers();
        } else {
          this.$refs.menumain.closeAllOpenDrawers();
        }
      } else if (val) {
        eventBus.$emit('SEARCH_VIEW_SEARCHBOX', false);
      }
    },
    openBag (val) {
      if (!this.bagInit && val) {
        this.bagInit = true;
      }
      if (!this.$mqAliases.desktop) {
        this.scrollLock(val, this.$refs.menubag);
      }
      if (val) {
        if (typeof this.$refs.menubag !== 'undefined') {
          this.$refs.menubag.initAllDrawers();
        }
        eventBus.$emit('SEARCH_VIEW_SEARCHBOX', false);
      } else {
        this.$refs.menubag.closeAllOpenDrawers();
        this.bagActiveDrawer = '';
        setTimeout(() => {
          document.getElementById('bagButton').focus();
        }, 330);
      }
    },
    cartCount: function (newvalue, oldvalue) {
      if (newvalue > oldvalue) {
        if (typeof this.$refs.bagIndicator !== 'undefined') {
          gsap.to(this.$refs.bagIndicator, 0.8, {
            scaleX: 0.8,
            scaleY: 0.8,
            yoyo: true,
            repeat: 1,
            delay: 0.75
          });
        }
      }
    }
  },
  methods: {
    closeBag () {
      setTimeout(() => {
        this.openBag = this.mouseOverBagPreview;
      }, 300);
    },
    setBagMouseState (e) {
      this.mouseOverBagPreview = e;
      if (!this.mouseOverBagPreview) {
        this.closeBag();
      }
    },
    closeNotification () {
      this.notificationSettings.ShowNotification = false;
      this.$cookies.set('notificationBarHidden', true, '30d');
      document.body.classList.remove('-notification-bar');
    },
    closeOpenNav () {
      this.openMenu = this.openBag = this.openMobileSearch = false;
    },
    scrollLock: function (lock, menu) {
      const $html = document.getElementsByTagName('html')[0];
      const $body = document.getElementsByTagName('body')[0];
      if (lock) {
        $html.style.overflow = 'hidden';
        $body.style.overflow = 'hidden';
        $html.style.overflowY = 'scroll';
        $html.style.height = '100%';
        $body.style.height = '100%';
      } else {
        $html.style.height = 'auto';
        $body.style.height = 'auto';
        $body.style.overflow = '';
        $html.style.overflowX = '';
        $html.style.overflowY = '';
      }
    }

  },

  async mounted () {
    if (this.$cookies.isKey('notificationBarHidden')) {
      this.notificationBarHidden = true;
    }
    if (this.notificationSettings.ShowNotification) {
      document.body.classList.add('-notification-bar');
    }
    if (this.blackTheme) {
      document.body.classList.add('-fill-black');
    }
  },
  created () {
    this.$store.dispatch('siteInfo/getSiteInformation');
    if (this.site === 'b2c' && this.headerCallCart) {
      this.$store.dispatch('bag/getCartItems');
    }
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.openBag = false;
      }
    });

    eventBus.$on('toggleDesktopMenu', (obj) => {
      const val = obj.val;
      const item = obj.item;
      // prevent menuitem from closing a sibling
      if (!val && item !== this.activeDesktopmenuItem && item !== null) {
        return;
      }
      this.activeDesktopmenuItem = item;
      this.scrollLock(false, this.$refs.menumain);
      if (val && this.openBag) {
        this.openBag = false;
      }
      clearTimeout(headerTimeout);
      if (val) {
        this.openMenu = true;
        document.getElementsByTagName('body')[0].classList.add('-openmenu');
      } else {
        headerTimeout = setTimeout(() => {
          this.openMenu = false;
        }, 330);
        document.getElementsByTagName('body')[0].classList.remove('-openmenu');
      }
    });

    eventBus.$on('SEARCH_VIEW_SEARCHBOX', obj => {
      const val = obj.val;
      if (val && !this.$mqAliases.desktop) {
        this.openMobileSearch = true;
      }
      if (this.$mqAliases.desktop) {
        this.openDesktopSearch = val;
      }
    });

    // open bag from f.eks add to bag button
    // makes sure that header is scrolled in view on mobile
    eventBus.$on('openBag', () => {
      // if (this.$mqAliases.desktop) {
      this.openBag = true;
      // }
    });
  },
  beforeOnMount () {
    eventBus.all.clear();
  }
};
</script>

<style lang="scss">
@import "@/scss/defaults.scss";

.-scroll-up {
  transform: translateY(-#{$main-header-height});

  &-bar {
    transform: translateY(-#{$main-header-height});
    transition: transform 0.25s !important;
  }

  @include media-breakpoint-up(lg) {
    .-usp-visible.view-uspbar & {
      transform: translateY(-#{$main-header-height + $usp-header-height});

      &-bar {
        transform: translateY(-#{$main-header-height + $usp-header-height});
      }
    }
  }
}
.bag-menu,
.main-menu {
  height: 100vh;
  color: inherit;
  background-color: inherit;
  transition: height $menu-anim-speed;
  overflow: scroll;
  .usp-poster {
    margin-right: -9px;
    margin-left: -9px;
    padding: 18px;
    border-top: 1px solid $gray-lighter;
    line-height: 18px;
    @include media-breakpoint-up(lg) {
      margin: 0;
      padding: 12px 18px;
    }
    li {
      display: inline;
      line-height: 0;
      margin-left: 0 !important;
      margin-right: 3px;
      &::before {
        display: none;
      }
      &::after {
        content: ".";
      }
    }
  }
}

.main-header {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 40000;

  transition: transform $menu-anim-speed ease-out,
  background-color $menu-anim-speed, opacity $menu-anim-speed;

  @include insertNewFont();
  @include headerTheme($white, $black);
  @include no-user-select;
  > section {
    @include headerTheme($white, $black);
    transition: transform $menu-anim-speed ease-out,
      background-color $menu-anim-speed;
  }

  &.-transparent-header.-transparent-header-theme-white {
    color: $white;
  }
  &.-transparent-header.-transparent-header-theme-black {
    color: $black;
  }

  &-icon-wrapper {
    display: flex;
    align-items: center;
    height: $main-header-height;
  }

  .search-field-mobile-wrapper {
    border-top: 1px solid transparent;
    transition: all $menu-anim-speed;
    &.-active {
      border-color: $gray-light;
    }
  }
  .search-field {
    background-color: inherit;
    @include media-breakpoint-down(md) {
      .search-field-icon svg {
        width: 16px;
        height: 16px;
      }
      .search-field-field {
        @include font-size(body);
        height: 48px;
      }
    }
  }

  &.-sticky {
    position: fixed;
    top: 0;
    z-index: 40000;
    width: 100vw;

    @include media-breakpoint-up(lg) {
      position: fixed !important;
      top: 0 !important;
      width: 100%;
    }
  }

  &.-opened {
    @include media-breakpoint-down(md) {
      > section {
        @include headerTheme(#{$black} !important, $white);
      }

      .main-header-wrapper {
        .bag-indicator {
          background-color: $white;
        }
        text {
          fill: $black !important;
        }
      }
      &.-search {
        @include headerTheme();
      }
    }
  }

  .main-header-wrapper {
    transition: background-color $menu-anim-speed;
    > section {
      > div {
        height: $main-header-height;
        align-items: center;
      }

      @include media-breakpoint-up(lg) {
        // make sure bag icon is clickable on desktop
        position: relative;
        z-index: 310000;
        background-color: transparent;
        pointer-events: none;
      }

      @include media-breakpoint-down(md) {
        background-color: transparent;
      }

      @include media-breakpoint-up(lg) {
        &.-black-theme {
          @include headerTheme($black, $white);
        }
        &.-blackest-theme {
          @include headerTheme($blackest, $white);
        }
      }
    }
  }

  /**
    * Black Theme
    */
  &.-black-theme {
    > section {
      @include headerTheme($black, $white);
    }
    .main-header-wrapper {
      color: $black;
    }
  }
  &.-blackest-theme {
    > section {
      @include headerTheme($blackest, $white);
    }
  }
  &.-scroll-up.-transparent-header-theme,
  &.-transparent-header {
    > section {
      background-color: transparent;
    }
    .main-header-wrapper {
      background-color: transparent;
    }
  }

  &.-transparent-header-theme-white,
  &.-transparent-header-theme-black {
    svg path,
    svg text {
      transition: all $menu-anim-speed;
    }
  }
  &.-transparent-header.-transparent-header-theme-white {
    @include headerTheme(transparent, $white);
    text {
      fill: $black;
    }
  }
  &.-transparent-header.-transparent-header-theme-black {
    @include headerTheme(transparent, $black);
    text {
      fill: $white;
    }
  }

  /*transitions*/
  .menu-enter-active {
    transition: height 0.2s;
  }
  .menu-leave-active {
    position: absolute;
    top: 60px;
    width: 100%;
    transition: opacity 0.1s;
  }
  .menu-enter {
    height: 0;
  }
  .menu-leave-to {
    opacity: 0;
  }

  .fade-leave-active,
  .fade-enter-active {
    transition: opacity 0.2s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  &.-fade-out {
    opacity: 0;
  }
}
</style>
